export class CaosConfigurationBackup {
    id: number;
    installationName: string;
    backupDate: Date;
    caosVersion: string;

    public parse(obj: any) {
        if (obj.Id != null && obj.Id != undefined) this.id = obj.Id;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.BackupDate) this.backupDate = obj.BackupDate;
        if (obj.CaosVersion) this.caosVersion = obj.CaosVersion;
    }
}
